import AntPopover, { type PopoverProps as AntPopoverProps } from "antd/lib/popover";
import { FC } from "react";

export type PopoverProps = AntPopoverProps;

export const Popover: FC<PopoverProps> = props => <AntPopover {...props} />;
